import BottomNavButton from 'components/BottomNavButton/BottomNavButton';

export default BottomNavButton;
